<template>
    <div class="footer">
        <div class="bottomPics">
            <span class="bottomArea" style="float: left;">
                <div class="bottomText">微信公众号</div>
                <img class="bottompic" src="/assets/weixin1.jpg">
            </span>
            <span class="bottomArea" style="float: right;">
                <div class="bottomText">bilibili</div>
                <img class="bottompic" src="/assets/bilibili1.png">
            </span>	
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.footer {
    margin-top: auto;
}
.footer {
    width: 100%;
    margin-left: 0px;
    margin-right: 0px;
    line-height: 1.45;
    background: #101010;
    padding: 30px 100px 200px 100px;
    color: black;
    position: relative;
    font-weight: 600;
    display: block;
    text-align: center;
}
.bottompic {
    max-height: 200px;
}
.bottomText {
    color: white;
    font-size: 25px;
    margin-bottom: 10px;
}
.bottomPics {
    margin: 0 auto;
    width: 80%;
}
@media (max-width: 950px) and (min-width: 500px) {
    .footer {
        padding: 30px 10px 150px 10px;
    }
    .bottompic {
        max-height: 150px;
    }
    .bottomText {
        color: white;
        font-size: 16px;
        margin-bottom: 5px;
    }
    .bottomPics {
        margin: 0 auto;
        width: 70%;
    }
}
@media (max-width: 500px) and (min-width: 400px) {
    .footer {
        padding: 30px 10px 100px 10px;
    }
    .bottompic {
        max-height: 100px;
    }
    .bottomText {
        font-size: 16px;
        margin-bottom: 5px;
    }
    .bottomPics {
        margin: 0 auto;
        width: 80%;
    }
}
</style>